import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const MediaUploadEditMode = ({ config }) => {
  const { t } = useTranslation(['create-event'])
  return (
    <div className="event-content">
      <div className="event-header">{config.header}</div>
      <div className="inputs-wrapper inline">
        {config.inputs.second && (
          <div className="input-row even-width" style={{ flex: 3 }}>
            <div className="input-container" style={{ alignItems: 'flex-start' }}>
              <div className="input-label">{config.inputs.second.label}</div>
              {config.inputs.second.render()}
            </div>
          </div>
        )}
        {config.inputs.image && (
          <div className="input-row even-width">
            <div className="input-container">
              <img
                className="input-image"
                src={config.inputs.image.image}
                alt={t('create-event:shared.eventImageAlt')}
              />
            </div>
          </div>
        )}
        {config.inputs.first && (
          <div className="input-row even-width" style={{ flex: 2 }}>
            <div className="input-container" style={{ alignItems: 'flex-end' }}>
              <div className="input-label">{config.inputs.first.label}</div>
              {config.inputs.first.render()}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

MediaUploadEditMode.propTypes = {
  config: PropTypes.object,
}

export default MediaUploadEditMode
